import { padZero } from '../datepicker/padZero';
var dateRegex = /^(\d{1,2})(\.| |-|\/)?(\d{0,2})\2?(\d{0,2}(\d{2})?)$/;
export function validateDate(date) {
    return dateRegex.exec(date);
}
export function isDateInputWithTwoDigitYear(value) {
    var _a;
    return ((_a = validateDate(value)) === null || _a === void 0 ? void 0 : _a[4].length) === 2;
}
export function getPaddedDateString(day, month, year) {
    return "".concat(padZero(day !== null && day !== void 0 ? day : 0), ".").concat(padZero(month !== null && month !== void 0 ? month : 0), ".").concat(year);
}
